import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface ModuleSectionTitleProps {
  module: string;
  section: string;
  showModule?: boolean;
  showSeparator?: boolean;

  preText?: ReactNode;
  preTextLink?: string;
  showPreTextBackIcon?: boolean;
}

export function ModuleSectionTitle({
  module,
  section,
  showModule = false,
  showSeparator = false,
  preText,
  preTextLink,
  showPreTextBackIcon,
}: ModuleSectionTitleProps) {
  const combinedPreText = (
    <>
      {showPreTextBackIcon ? '← ' : null}
      {preText}
    </>
  );
  const preTextElement = preTextLink ? (
    <Link to={preTextLink}>{combinedPreText}</Link>
  ) : (
    combinedPreText
  );
  return (
    <span className="flex flex-col">
      {preText && (
        <div className="text-sm text-color-text-secondary">
          {preTextElement}
        </div>
      )}
      <div className="flex items-center gap-2 text-xl font-medium whitespace-nowrap">
        {showModule && (
          <span
            className={`${showSeparator ? 'text-gray-400 font-normal' : ''}`}
          >
            {module}
          </span>
        )}

        {showModule && showSeparator && (
          <span className="text-gray-300">—</span>
        )}

        <span>{section}</span>
      </div>
    </span>
  );
}
